import { action } from "mobx";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Alert, Typography } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import type { SnackStore } from "@/stores/SnackStore";

const autoHideDuration = 30000; // 30 seconds

export const Snack = observer((props: { snackStore: SnackStore }) => {
  const { snackStore } = props;
  const { t } = useTranslation();

  const handleClose = action(() => {
    snackStore.isOpen = false;
  });

  return (
    <Snackbar
      open={snackStore.isOpen}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      autoHideDuration={autoHideDuration}
    >
      <Alert variant="filled" onClose={handleClose} severity={snackStore.severity}>
        <Typography variant="body1">
          {t(snackStore.message || "Oops! Something went wrong, and we're not sure why.")}
        </Typography>
      </Alert>
    </Snackbar>
  );
});
